const appendHTML = (parent, html) => {
  const fragment = document.createDocumentFragment();
  const newChild = document.createElement("div");
  newChild.innerHTML = html;
  while (newChild.hasChildNodes()) {
    fragment.appendChild(newChild.firstChild);
  }
  parent.appendChild(fragment);
};
const prependHTML = (parent, html) => {
  const fragment = document.createDocumentFragment();
  const newChild = document.createElement("div");
  newChild.innerHTML = html;
  while (newChild.hasChildNodes()) {
    fragment.prepend(newChild.firstChild);
  }
  parent.prepend(fragment);
};
export { appendHTML, prependHTML };